const questionsByCategory = [
  {
    category: "Tech",
    questions: [
      { id: 231, left: "Boilerplate sucks", right: "Magic sucks" },
      {
        id: 234,
        left: "Performant code is important",
        right: "It's the root of all evil",
      },
      { id: 235, left: "Boring old tech", right: "Shiny new stuff" },
      { id: 241, left: "Tabs", right: "Spaces" },
      { id: 243, left: "Functional programming", right: "OOP" },
      { id: 244, left: "Linter", right: "Fuck that" },
      { id: 246, left: "Refactoring is important", right: "Meh" },
      {
        id: 248,
        left: "Test your code thoroughly",
        right: "That's what QA is for",
      },
      {
        id: 252,
        left: "Program by sketching",
        right: "Gameplan before coding",
      },
      { id: 256, left: "Libraries", right: "Frameworks" },
      { id: 257, left: "Monolith", right: "Microservices" },
      { id: 258, left: "Relational DB", right: "NoSQL" },
      { id: 265, left: "Raw SQL", right: "ORM" },
      { id: 266, left: "Strongly typed", right: "Weakly typed" },
      { id: 267, left: "Native apps", right: "Web is fine" },
      { id: 269, left: "Best practices", right: "Whatever works" },
      { id: 270, left: "Roll your own", right: "Use a library" },
      { id: 271, left: "Git via command line", right: "Git via GUI" },
      { id: 272, left: "Print statements", right: "Debugger" },
      {
        id: 273,
        left: "Spend 100 full seconds on naming",
        right: "It'll be fine",
      },
      { id: 274, left: "TDD", right: "Test when I wanna" },
      { id: 275, left: "Style guide", right: "Fuck that" },
      {
        id: 276,
        left: "CS fundamentals are important",
        right: "No they're not",
      },
    ],
  },
  {
    category: "Culture",
    questions: [
      {
        id: 232,
        left: "Pixel perfect",
        right: "Let's focus on more important things",
      },
      {
        id: 233,
        left: "Clear requirements upfront",
        right: "We'll figure it out",
      },
      {
        id: 236,
        left: "Employees shouldn't talk about salary",
        right: "Fight the power",
      },
      { id: 237, left: "Two weeks notice", right: "Who cares" },
      { id: 240, left: "Document everything", right: "Fuck that" },
      {
        id: 245,
        left: "Code review is awesome",
        right: "Code review is annoying",
      },
      {
        id: 255,
        left: "Write in complete sentences on Slack",
        right: "Fuck that",
      },
      {
        id: 261,
        left: "Slack threads",
        right: "Ain't nobody got time for that",
      },
      {
        id: 262,
        left: "Sales and marketing are crucial",
        right: "The product is what matters",
      },
      {
        id: 263,
        left: "Managers play an important role",
        right: "We don't need 'em",
      },
    ],
  },
  {
    category: "Personal",
    questions: [
      { id: 238, left: "Early retirement", right: "Career" },
      { id: 239, left: "Hacker", right: "Software engineer" },
      { id: 242, left: "Learn by doing", right: "Learn by reading" },
      { id: 247, left: "Dedicated", right: "It's just a job" },
      { id: 249, left: "In office", right: "Work from home" },
      { id: 250, left: "I'm a good developer", right: "I'm an imposter" },
      { id: 251, left: "CS degree", right: "Self taught" },
      {
        id: 253,
        left: "I like working with people",
        right: "I do it because I have to",
      },
      { id: 254, left: "Let's hop on a call", right: "Async" },
      { id: 259, left: "FAANG", right: "Fuck that" },
      {
        id: 260,
        left: "Continuous education",
        right: "They don't pay me enough for that",
      },
      {
        id: 264,
        left: "I want to be challenged",
        right: "It's just my day job",
      },
      { id: 268, left: "Mac", right: "PC" },
    ],
  },
];

export default questionsByCategory;
